import { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";

function Items({ currentItems }) {
  return <>{currentItems?.map((item, index) => item)}</>;
}

export const PaginatedItems = ({
  items = [],
  paginacion,
  onPageChange, // callback que envías al padre para pedir más datos al backend
}) => {
  const [currentItems, setCurrentItems] = useState(items);

  useEffect(() => {
    setCurrentItems(items);
  }, [items]);

  const handlePageClick = (event) => {
    const newPage = event.selected + 1; // ReactPaginate empieza en 0, backend en 1

    onPageChange(newPage);
  };

  return (
    <div className="col-12">
      <Items currentItems={currentItems} />
      {paginacion?.totalPaginas > 0 && (
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          previousLabel="<"
          onPageChange={handlePageClick}
          // ahora vienen desde el backend:
          pageCount={paginacion?.totalPaginas || 0}
          forcePage={(paginacion?.pagina || 1) - 1}
          marginPagesDisplayed={0}
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination ms-auto me-auto w-250px"
          activeClassName="active"
        />
      )}
    </div>
  );
};
